import { Container } from 'pixi.js';
import type { IAPProduct } from '../../app/iap/types';
import { PurchaseResultLayout } from '../../../layouts/mainMenu/PurchaseResultLayout';
import { applyLayoutState } from '../../libs/layouts/populateLayouts/applyLayoutState';
import { PurchaseItemLayout } from '../../../layouts/mainMenu/PurchaseItemLayout';
import { setIconForInventory } from './utils/setIconForInventory';
import type { InventoryItem } from '../../app/resources/types';
import { centerElements } from '../../game/utils/centerElements';
import { registerResizableObject } from '../../utils/pixi/registerResizableObject';

export class PurchaseResultView extends Container {
  private readonly layout = new PurchaseResultLayout();

  constructor(product: IAPProduct, successful = false) {
    super();

    this.addChild(this.layout.root);

    if (successful) {
      this.initSuccessful(product);
    } else {
      applyLayoutState(this.layout, 'failed');
    }

    registerResizableObject(this);

    void this.startAnimation();
  }

  private async startAnimation(): Promise<void> {
    await this.tweenFrom({ alpha: 0 }, 200, 'sinIn', true).asyncOnComplete();
    await this.wait(3000);
    await this.tweenTo({ alpha: 0 }, 300, 'sinIn', true).asyncOnComplete();
    this.destroy({ children: true });
  }

  private initSuccessful(product: IAPProduct): void {
    const { itemsContainer } = this.layout;

    Object.entries(product.rewards).forEach(([key, value]) => {
      const item = key as InventoryItem;
      const { root, icon, amount } = new PurchaseItemLayout();
      setIconForInventory(icon, item);
      amount.text = value;
      itemsContainer.addChild(root);
    });

    this.alignItems();
  }

  private alignItems(): void {
    const { itemsContainer } = this.layout;

    if (itemsContainer.children.length <= 4) {
      centerElements(itemsContainer.children, 40);
      return;
    }

    const firstRow = itemsContainer.children.slice(0, 3);
    firstRow.forEach((item) => {
      item.y = -30;
    });
    centerElements(firstRow, 40);
    const lastRow = itemsContainer.children.slice(3);
    lastRow.forEach((item) => {
      item.y = 30;
    });
    centerElements(lastRow, 40);
  }

  public resize(width: number, height: number): void {
    this.props({
      x: Math.round(width * 0.5),
      y: Math.round(height * 0.5),
    });
  }
}
